<template>
  <div class="mobile-notifications-card">
    <img src="/images/promo/connect-features/mobile-notifications-card.svg" alt="Notifications card" />
  </div>
</template>

<script>
export default {};
</script>
